import { combineReducers } from "redux";
import { objectsSlice } from "../app/reduxSlices/objectsSlice";

export const shiftReducer = combineReducers({
    workTimes: objectsSlice({ name: "workTimes" }).reducer,
    shifts: objectsSlice({ name: "shifts" }).reducer,
    shiftCategories: objectsSlice({ name: "shiftCategories" }).reducer,
    shiftPatterns: objectsSlice({ name: "shiftPatterns" }).reducer,
    attSettingSubGroups: objectsSlice({ name: "attSettingSubGroups" }).reducer,
    missions: objectsSlice({ name: "missions" }).reducer,
    myMissions: objectsSlice({ name: "myMissions" }).reducer,
    trafficTypes: objectsSlice({ name: "trafficTypes" }).reducer,
    userTrafficTypes: objectsSlice({ name: "userTrafficTypes" }).reducer,
    missionTrafficTypes: objectsSlice({ name: "missionTrafficTypes" }).reducer,
    userTraffics: objectsSlice({ name: "userTraffics" }).reducer,
    myUserTraffics: objectsSlice({ name: "myUserTraffics" }).reducer,
    trafficsReport: objectsSlice({ name: "trafficsReport" }).reducer,
    myTrafficsReport: objectsSlice({ name: "myTrafficsReport" }).reducer,
});

